<template>
  <div class="container">
    <head-nav-bar :title="title" :fixed="true" />
    <form class="mt-header-nav" action="/">
      <van-search
        v-model="keyword"
        placeholder="请输入搜索关键词"
        show-action
        @search="onSearch"
        @clear="onClear"
      >
        <div slot="action">
          <router-link
            :to="{
              path: '/serve/pre-order/selectDoctorList',
              query: { type: type }
            }"
          >
            <span class="font-color-active">按医生选择 ></span>
          </router-link>
        </div>
      </van-search>
    </form>
    <div>
      <div v-if="departmentList.length">
        <van-cell-group>
          <van-cell
            v-for="(item, index) in departmentList"
            :key="index"
            :value="item.text"
            @click="onItemClick(item)"
          />
        </van-cell-group>
      </div>
      <div v-else>
        <van-tree-select
          :items="departmentData"
          :main-active-index="mainActiveIndex"
          :active-id="activeId"
          @navclick="onNavClick"
          @itemclick="onItemClick"
          :height="treeHeight"
        />
      </div>
    </div>
    <div>
      <ContactCard :show="false" v-model="contact" />
    </div>
  </div>
</template>

<script>
import { Search, TreeSelect, CellGroup, Cell } from "vant";
import { treeTransArray } from "@/utils/common";
import { mapState, mapActions } from "vuex";
import ContactCard from "@/components/ContactCard";

export default {
  name: "Department",
  components: {
    [Search.name]: Search,
    [TreeSelect.name]: TreeSelect,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    ContactCard
  },
  data() {
    return {
      title: "选择科室",
      type: "",
      keyword: "",
      tabActive: 0,
      mainActiveIndex: 1,
      // activeId: 0,
      treeHeight: 500,
      data: [],
      departmentData: [],
      departmentList: [],
      contact: {}
    };
  },
  created() {
    this.type = this.$route.query.type;
    this.loadData();
  },
  computed: {
    ...mapState({
      order: state => state.order
    }),
    activeId() {
      return this.order.DepartmentId;
    }
  },
  // watch: {
  //   contact(contact) {
  //     if (!contact.Id) {

  //     }
  //   }
  // },
  methods: {
    ...mapActions(["setDepartment"]),
    loadData() {
      this.$post("Department_Tree", {}).then(res => {
        this.data = res.data.departmentList;
        if (res.data.level === 1) {
          //只有一级
          this.departmentList = res.data.departmentList;
          this.departmentData = [];
        } else {
          this.departmentData = res.data.departmentList;
          this.departmentList = [];
        }
      });
    },
    onSearch(keyword) {
      console.log(keyword);
      if (keyword) {
        const departmentDataArray = treeTransArray(this.data, "children");
        const departmentList = departmentDataArray.filter(item => {
          if (item.text.indexOf(keyword) > -1 && !item.children) {
            return true;
          }
          return false;
        });
        this.departmentList = departmentList;
      } else {
        this.departmentList = this.data;
      }
    },
    onClear() {
      this.departmentList = this.data;
    },

    onNavClick(index) {
      this.mainActiveIndex = index;
    },

    onItemClick(data) {
      // this.activeId = data.Id;
      this.setDepartment(data);
      this.$router.push({
        name: "servePreOrderDoctorList",
        query: {
          type: this.type
        }
      });
      // this.$emit("stepChange", 1);
    },

    onDoctorLoad() {
      setTimeout(() => {
        for (let i = 0; i < 10; i++) {
          this.doctor.list.push(this.doctor.list.length + 1);
        }
        // 加载状态结束
        this.doctor.loading = false;

        // 数据全部加载完成
        if (this.doctor.list.length >= 100) {
          this.doctor.finished = true;
        }
      }, 500);
    }
  }
};
</script>

<style lang="less" scoped></style>
